import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Button, Form, Input, Label, Select } from "../../../styles";
import { useUserContext } from "../../../context/user_context";
import Api from "../../../api/axios";
import { toast } from "react-toastify";
import { allGender, emailPlaceholder, namePlaceholder, phonePlaceholder } from "../../../utils/data";
import CustomSelect from "../../../utils/CustomSelect";
import MiniLoader from "../../../utils/MIniLoader";
import { useEmployeeContext } from "../../../context/employee_context";


function AddStaff(props) {

  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({});

  const {
    showAddStaff, CloseAddStaff,
    getStaffData
  } = useEmployeeContext();

  const {
    btoken, stoken,
    storeLoading, allStores, getAllStores,
  } = useUserContext();


  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  function clear() {
    setformField({
      mail: '',
      fname: '',
      lname: '',
      gender: '',
      phone: '',
      username: ''
    });
  }

  function getFn() {
    getAllStores();
  }


  function submitFn(e) {
    e.preventDefault();
    if (formField.mail,
      formField.fname,
      formField.lname,
      formField.gender,
      formField.phone,
      formField.username) {
      setissending(true);
      const data = {
        btoken,
        stoken: formField.stoken,
        mail: formField.mail,
        fname: formField.fname,
        lname: formField.lname,
        gender: formField.gender,
        phone: formField.phone,
        username: formField.username,
        position: formField.position,
      };

      Api.post(`/addStaff`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            getStaffData();
            CloseAddStaff();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.error("Empty Fields !!!");
    }
  }

  const gender = allGender?.map(({ name, value }) => {
    return (
      { label: name, value }
    );
  });
  const stores = allStores?.map(({ storename, token }) => {
    return (
      { label: storename, value: token }
    );
  });


  return (
    <>

      <Modal
        show={showAddStaff}
        onHide={CloseAddStaff}
        backdrop="static"
        keyboard={true}
        onEnter={() => getFn()}
        centered
        size="md"
      // onEnter={getFeatures}
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text">
              Create new Staff
            </h6>
          </Modal.Header>
          <div className="container">

            <Form onSubmit={(e) => submitFn(e)}
            >

              <Label> First Name: <span>*</span> </Label>
              <Input
                type="text"
                name="fname"
                onChange={handleChange}
                value={formField.fname}
                placeholder={namePlaceholder}
                required
              />
              <Label> Last Name: <span>*</span></Label>
              <Input
                type="text"
                name="lname"
                onChange={handleChange}
                value={formField.lname}
                placeholder={namePlaceholder}
                required
              />

              <Label> Email:<span>*</span> </Label>
              {/* <Button
                    id="PopoverFocus"
                    type="button"
                    className="shadow-none"
                    color="none p-0"

                  >
                    <i className="bi bi-info-circle-fill pry-text h12" />
                  </Button>
                  <UncontrolledPopover
                    placement="top"
                    target="PopoverFocus"
                    trigger="focus"
                  >
                    <PopoverHeader className="sec-bold pry-bold-text">
                      NOTE
                    </PopoverHeader>
                    <PopoverBody
                      className="">
                      If the new staff has a RENI account, input the RENI account email, else put the staff email and a new RENI account will be created by default after adding the staff.
                    </PopoverBody>
                  </UncontrolledPopover> */}
              <Input
                type="email"
                placeholder={emailPlaceholder}
                name="mail"
                onChange={handleChange}
                value={formField.mail}
                required
              />

              <Label> Phone Number: <span>*</span></Label>
              <Input
                type="number"
                placeholder={phonePlaceholder}
                name="phone"
                onChange={handleChange}
                value={formField.phone}
                required
              />

              <Label> Username: <span>*</span> </Label>
              <Input
                type="text"
                name="username"
                onChange={handleChange}
                value={formField.username}
                placeholder="e.g. janedoe"
                required
              />
              <Label> Position: <span>*</span> </Label>
              <Input
                type="text"
                name="position"
                onChange={handleChange}
                value={formField.position}
                placeholder="e.g. Staff"
                required
              />

              <Label> Gender: <span>*</span>
              </Label>
              <CustomSelect
                options={gender}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, gender: e.value }))}
                placeholder='Select Gender'
                required
              />
              <Label> Choose Store: <span>*</span>
                <MiniLoader
                  load={storeLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={stores}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, stoken: e.value }))}
                placeholder='Select Store'
                required
              />


              <div className="col-md-12 mb-4 mx-auto text-center">
                <Button
                  pry
                  type="submit"
                  className="btn m-0 w-lg-75 w-md-100"
                  disabled={issending}
                >
                  {issending ? 'loading...' : 'Submit'}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AddStaff;
